import { Injectable } from '@angular/core';
import { DirectusService } from './directus.service';
import { AlertController, LoadingController, ToastController } from '@ionic/angular';
import { BehaviorSubject, from } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { databaseSettings } from 'src/environments/database-settings';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root',
})
export class AppDataService {
  currentLoading = null;
  project = databaseSettings.directus.split('/').pop()
  public systemLanguages = [];
  LstLanguages = [];
  routPath: any;
  routData: any;
  ApiUrl: any = 'https://dev-backend-cms.dexycon.com/'
  // ApiPath: string = "http://localhost:3000/"
  ApiPath: string = "https://dev-backend-cms.dexycon.com/"
  constructor(
    private directusService: DirectusService,
    private loadingCtrl: LoadingController,
    private toast: ToastController,
    private alertCtrl: AlertController,
    private router: Router,
  ) { }

  getUser(user) {
    return this.directusService.api.getUser(user);
  }

  geCurrentLoggedIntUserRole() {
    return from(this.directusService.api.getMe({ fields: '*.*' }))
      .pipe(
        map((userInfo) => {
          return userInfo.data.role.name;
        })
      )
      .toPromise();
  }

  getAllCollections() {
    return this.directusService.api.getCollections();
  }

  async alert(message) {
    const toast = await this.toast.create({
      message,
      duration: 2000
    });
    toast.present();
  }
  async showAlertPopup(header, message, navigateOnOk?: string) {
    const alert = await this.alertCtrl.create({
      header: header,
      message: message,
      buttons: [{
        text: 'Okay',
        handler: () => {
          if (navigateOnOk) {
            this.router.navigate([navigateOnOk])
          }
        }
      }]
    })
    alert.present();
  }
  getData(collectionName, id?, fields?, sort?, filter?) {
    let params = { fields: '*.*' };
    if (fields) {
      Object.assign(params, { fields: fields });
    }
    if (sort) {
      Object.assign(params, { sort: sort });
    }
    if (filter) {
      Object.assign(params, { filter: filter });
    }
    if (id) {
      return this.directusService.api.getItem(collectionName, id, params);
    } else {
      return this.directusService.api.getItems(collectionName, params);
    }
  }

  getGalleryImages(collectionName, id?) {
    return this.directusService.api.getItems(collectionName, {
      filter: {
        gallery_id: id
      },
      fields: ['*.*.*']
    });
  }

  getCollectionData(collectionName) {
    return this.directusService.api.getCollection(collectionName);
  }

  getFile(id) {
    return this.directusService.api.api.get('files/' + id);
  }

  uploadFile(file) {
    const formData = new FormData();
    formData.append('data', file);
    return this.directusService.api.api.post('files', formData);
  }

  deleteFile(id) {
    return this.directusService.api.api.delete('files/' + id);
  }

  async presentLoader(options: object) {
    // Dismiss previously created loading
    if (this.currentLoading != null) {
      this.currentLoading.dismiss();
    }

    this.currentLoading = await this.loadingCtrl.create(options);

    return await this.currentLoading.present();
  }

  async dismissLoader() {
    // console.log('Outside If inside dismiss loader');
    await this.loadingCtrl.dismiss();
    if (this.currentLoading != null) {
      // console.log('Inside if inside dismiss loader');
      await this.loadingCtrl.dismiss();
      this.currentLoading = null;
    }
    return;
  }

  addNewItem(collection, body) {
    // console.log(collection, body)
    return this.directusService.api.createItem(collection, body);
  }
  updateItem(collection, primaryKey, data) {
    return this.directusService.api.updateItem(collection, primaryKey, data);
  }

  getHomeMenu(collection, i): Promise<any> {
    return this.directusService.api.getItems('slideout_menu', {
      filter: {
        is_home_page: i
      },
      fields: ['*.*']
    });
  }
  updateItems(collection, data) {
    return this.directusService.api.updateItems(collection, data);
  }

  async getSystemLanguagesData(collection) {
    if (this.LstLanguages && this.LstLanguages.length > 0) {
      // console.log(this.LstLanguages)
      this.systemLanguages.push([...this.LstLanguages]);
    } else {
      // const temp: any = await this.getData(collection);
      const temp: any = await this.directusService.api.api.get(databaseSettings.directus + '/items/system_languages', { fields: '*.*.*.*', limit: 600 });
      this.LstLanguages = temp.data;
      this.systemLanguages.push([...temp.data]);
    }
    return
  }

  getHome(collectionName, id?, fields?) {
    if (id) {
      return this.directusService.api.getItem(collectionName, id, { fields: '*.*.*' });
    } else {
      return this.directusService.api.getItems(collectionName, { fields: '*.*.*' });
    }
  }

  sendWelcomeEmail(data?) {
    // console.log(this.project)
    return this.directusService.api.api.post(this.ApiUrl + 'fexpert/sendWelcomeMail?db=' + this.project, data);
  }

  sendResetPasswordEmail(data?) {
    this.presentLoader({
      message: 'Loading...',
    });
    return this.directusService.api.api.post(this.ApiPath + 'api/sendForgotPasswordEmail', data);
  }
  changePassword(data?) {
    this.presentLoader({
      message: 'Loading...',
    });
    return this.directusService.api.api.post(this.ApiPath + 'api/changePassword', data);
  }
}